import { gql } from 'graphql-request'

export const ManyGlobalPagesQuery = gql`
  # sort
  query AllGlobalPages(
    $limit: Int! = 100,
    $page:Int! = 1,
    $locale: LocaleInputType!
    $sort: String = "title:asc"
  ) {
    GlobalPages(
      limit: $limit,
      sort: $sort,
      page: $page,
      locale: $locale
    ) {
      docs {
        id
        title
        globalType
      }
      totalDocs
      limit
      totalPages
      page
      pagingCounter
      hasPrevPage
      hasNextPage
      prevPage
      nextPage
    }
  }
`
